import {type} from "@colyseus/schema";
import {Ingredient} from "./ingredients";
import {directionOf, Directions} from "./direction";
import {GameSchema, Position} from "./game_element_schema";

export let SPEED = 160;

export enum CookSpriteNames {
    EskimoNinja = "EskimoNinja",
    RedNinja2 = "RedNinja2",
    BlueNinja = "BlueNinja",
    GrayNinja = "GrayNinja",
    GreenNinja = "GreenNinja",
    MaskedNinja = "MaskedNinja",
    Noble = "Noble",
    Woman = "Woman",
}

export const COOK_SPRITE_ORDER: CookSpriteNames[] = [ // I do have my preferences
    CookSpriteNames.RedNinja2,
    CookSpriteNames.EskimoNinja,
    CookSpriteNames.BlueNinja,
    CookSpriteNames.GrayNinja,
    CookSpriteNames.GreenNinja,
    CookSpriteNames.MaskedNinja,
    CookSpriteNames.Noble,
    CookSpriteNames.Woman,
]

export class Cook extends GameSchema {
    @type("string") skinName: CookSpriteNames;
    @type("string") playerName: string = '';

    @type("number") velocityX: number
    @type("number") velocityY: number

    @type("string") carries_id: string | undefined = undefined
    @type("string") direction: Directions
    private _carries: Ingredient;


    constructor(sessionId: string, sprite_key) {
        super();
        this.id = sessionId
        this.skinName = sprite_key
        this.direction = Directions.DOWN
        this.setVelocity(0, 0)
    }

    stop() {
        this.velocityX = 0;
        this.velocityY = 0;
    }

    setVelocity(velocityX: number, velocityY: number) {
        let {x, y} = this.normalizeVelocity(velocityX, velocityY)
        this.velocityX = x
        this.velocityY = y
        let vX = this.velocityX;
        let vY = this.velocityY;
        this.direction = directionOf(vY, vX, this.direction);
    }

    private normalizeVelocity(x, y): Position {
        let total_sqr_velocity = x ** 2 + y ** 2;
        let ratio;
        if (total_sqr_velocity > SPEED ** 2) {
            ratio = Math.sqrt(SPEED ** 2 / total_sqr_velocity);
            x *= ratio
            y *= ratio
        }
        return {x: x, y: y}
    }

    carry(ingredient: Ingredient) {
        // @todo do I really want birelational logic here?
        if (this.carries_id == ingredient.id)
            return
        this.carries_id = ingredient.id
        this._carries = ingredient
        ingredient.beCarried(this)
    }

    drop(ingredient ?: Ingredient): Ingredient {
        if (ingredient == undefined) {
            ingredient = this._carries
        }
        if (this._carries == undefined)
            return undefined

        let oldId = this._carries
        this.carries_id = undefined
        this._carries = undefined
        ingredient.beDropped()
        return oldId
    }

    get isCarrying(): boolean { return this.carries_id !== undefined; } // yup, it's open carry only /s

    get carrying(): Ingredient {
        return this._carries;
    }

    get printableId(): string { return `${this.id}-${this.skinName}` }
    get printablePosition(): string { return `(${this.x},${this.y}) facing ${this.direction}` }
}

